import { render, staticRenderFns } from "./HandbookNavigation.vue?vue&type=template&id=e31a0b0c&lang=pug&"
import script from "./HandbookNavigation.vue?vue&type=script&lang=ts&"
export * from "./HandbookNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports